import {
  Component,
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  ChangeDetectorRef,
} from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import {
  KreFormFieldConfig,
  KreTableFieldConfig,
  KreFormInfo,
  clone,
  KreTableConfig,
  KreFormCommonService,
  KreFormBuilder,
} from "@kre-form/core";
import { NzModalService } from "ng-zorro-antd/modal";
import { NzMessageService } from "ng-zorro-antd/message";
import * as _ from "lodash";
import { KreFormAntService } from "../../tools/service";
import {
  FormLayout,
  LayoutPanel,
  LayoutColumn,
  KreTableBusiness,
  ICheckedField,
  IBusinessTable,
  Itable,
  IDesignFormAPI,
  IItem,
} from "../../tools/util";
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from "@angular/cdk/drag-drop";
import { KreDialogService } from "../../service/dialog.service";
import { DataService } from "../../service/data.service";
import { KreAntCommonService } from "../../tools/commonService";
import { KreTransferService } from "../../tools/transferService";
import { KreDesginToFormService } from "../../tools/tableFieldService";
import { KreFormDSField } from "../field/index.component";
import { KreFormDSFieldLabel } from "../field-label/index.component";
import { KreFormDesignTable } from "../table/table.component";
import { KreFormDesignTables } from "../tables/table.component";
import { group } from "@angular/animations";
import { filter } from "rxjs/operators";

export interface IFormJSON {
  code: string;
  name: string;
  type: any;
  column: string;
  row: string;
  fields: KreFormFieldConfig[];
}

@Component({
  selector: "kreform-designx",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.less"],
  providers: [
    DataService,
    KreAntCommonService,
    KreTransferService,
    KreDialogService,
    KreFormAntService,
  ],
})
export class KreFormDesignDetailX implements OnInit, OnChanges, OnDestroy {
  @Input() showForm = true;
  @Input() formCode: string = "";
  @Input() layout = true;
  @Input() api: IDesignFormAPI = {
    tables: { url: "assets/mockData/business.json" },
    form: { url: "assets/mockData/formInfo.json" },
  };
  @Input() showAnchorList: boolean = true;

  /*
    表字段集合
  */
  _business_tables: IBusinessTable = {
    primary: {},
    child: { single: [], multiple: [] },
  };
  @Input()
  set business_tables(value: any) {
    this._business_tables = value;
  }
  get business_tables() {
    return this._business_tables;
  }

  _langConfig: any[] = [];
  @Input()
  set langConfig(value: any) {
    this._langConfig = value;
  }
  get langConfig() {
    return this._langConfig;
  }

  // _lang: string = "zh-cn";
  // @Input()
  // set lang(value: any) {
  //   this._lang = value;
  // }
  // get lang() {
  //   return this._lang;
  // }

  _triggerJson: any = {};
  @Input()
  set triggerJson(value: any) {
    this._triggerJson = value;
  }
  get triggerJson() {
    return this._triggerJson;
  }

  _calculateRuleJson: any = {};
  @Input()
  set calculateRuleJson(value: any) {
    this._calculateRuleJson = value;
  }
  get calculateRuleJson() {
    return this._calculateRuleJson;
  }

  _options: IItem[] = [];
  @Input()
  set options(value: any) {
    this._options = value;
  }
  get options() {
    return this._options;
  }

  /*
    表设置
  */
  _business_form: IFormJSON = {
    code: "",
    name: "",
    type: "",
    column: "",
    row: "",
    fields: [],
  };
  @Input()
  set business_form(value: IFormJSON) {
    if (value != undefined && value != null) {
      this._business_form = value;
      this.initFormInfo(this._business_form);
      this.cd.detectChanges();
    }
  }
  get business_form() {
    return this._business_form;
  }

  @Input() isSaveButton = false;
  @Output() saveEvent: EventEmitter<string> = new EventEmitter<string>();
  @Output() cancelEvent: EventEmitter<string> = new EventEmitter<string>();
  @Output() previewEvent: EventEmitter<string> = new EventEmitter<string>();
  @Output() actionEvent: EventEmitter<any> = new EventEmitter<string>();

  pageStatus: number = 1;

  form_model: any = {};
  form_group = new FormGroup({});
  form_fields: KreFormFieldConfig[] = [];

  kreFormInfo: KreFormInfo = {};

  layout_column: string = "layout-column-3";
  layout_row: string = "layout-row-1";

  table_Data: Itable[] = [];

  anchorList: any[] = [];
  anchorDevList: any = {};
  key: string = "";
  AddReferProcessDisabled: boolean = false;
  constructor(
    private cd: ChangeDetectorRef,
    private message: NzMessageService,
    private modalService: NzModalService,
    private kreFormAntService: KreFormAntService,
    public kreDialogService: KreDialogService,
    public dataService: DataService,
    public kreAntCommonService: KreAntCommonService,
    public kreTransferService: KreTransferService,
    public kreDesginToFormService: KreDesginToFormService,
    public kreFormCommonService: KreFormCommonService,
    public formBuilder: KreFormBuilder
  ) {}

  ngOnInit() {
    this.kreFormAntService.btnEvent.subscribe((res: any) => {
      if (
        res["type"] == "delete" ||
        res["type"] == "up" ||
        res["type"] == "down"
      ) {
        let cloneField = _.cloneDeep(res["field"]);
        let checkedList =
          this.kreTransferService.getGroupCheckFields(cloneField);
        if (checkedList == null || checkedList.length == 0) {
          this.message.warning("您当前没有选中任何项!");
          return;
        }
      }
      switch (res["type"]) {
        case "delete":
          this.modalService.confirm({
            nzTitle: "提示",
            nzContent: `您确定要删除选中项？<br/><span class="delete_tips" >提示：如果该字段是内置字段，则删除无效。</br>&emsp;&emsp;&emsp;如果该字段关联了触发事件，则删除无效。</span>`,
            nzOnOk: () => {
              this.groupBtnDeleteFields(res["field"]);
            },
          });
          break;
        case "up":
        case "down":
          this.groupBtnMoveUpOrDown(res["field"], res["type"]);
          break;
        case "item":
          this.groupBtnTableFields(res["field"]);
          break;
        case "remark":
        case "line":
          this.groupBtnAddLineRemark(res["field"], res["type"]);
          break;
        case "edit":
          this.editFormFieldConfig(res["field"]);
          break;
        default:
          break;
      }
    });

    this.kreFormAntService.fieldEvent.subscribe((res: any) => {
      let sign = res["sign"];
      if (sign == "edit") {
        this.editFormFieldConfig(res["field"]);
      } else if (sign == "delete") {
        this.modalService.confirm({
          nzTitle: "提示",
          nzContent: `您确定要删除该项？<br/><span class="delete_tips" >提示：如果该字段是内置字段，则删除无效。</br>&emsp;&emsp;&emsp;如果该字段关联了触发事件，则删除无效。</span>`,
          nzOnOk: () => {
            this.deleteFormFieldConfig(res["field"]);
          },
        });
      }
    });
    this.initAnchorList();
    this.AddReferProcessDisabled = this.business_form.fields.some(
      (el) =>
        el.key === "comprehensive$df_comprehensiveapply$associationprocess"
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.business_tables) {
      this.initTableFieldStatus();
    }
  }

  ngOnDestroy() {}

  /*按钮区域---begin*/

  btnSave() {}

  btnCancel() {}

  btnPreview() {}

  btnDelete() {
    let checkedList = this.getCheckFields();
    if (checkedList == null || checkedList.length == 0) {
      this.message.warning("您当前没有选中任何项!");
      return;
    }
    let isRelativeEvent = false;
    if (!!this.triggerJson && !_.isEmpty(this.triggerJson)) {
      Object.keys(this.triggerJson).forEach((key) => {
        if ((checkedList as any[])!.some((el) => el.field.key === key)) {
          isRelativeEvent = true;
        }
      });
      Object.keys(this.triggerJson).forEach((key) => {
        (this.triggerJson[key] as any[])!.forEach((ele) => {
          if (
            (checkedList as any[])!.some((el) => el.field.key === ele.fieldKey)
          ) {
            isRelativeEvent = true;
          }
        });
      });
    }

    if (!!this.calculateRuleJson && !_.isEmpty(this.calculateRuleJson)) {
      // isRelativeEvent = (Object.keys(this.calculateRuleJson) as any).includes(
      //   field.key
      // );

      Object.keys(this.calculateRuleJson).forEach((key) => {
        if ((checkedList as any[])!.some((el) => el.field.key === key)) {
          isRelativeEvent = true;
        }
      });

      Object.keys(this.calculateRuleJson).forEach((key) => {
        if (
          !!this.calculateRuleJson[key] &&
          !!this.calculateRuleJson[key]["calculateValue"]
        ) {
          if (
            (checkedList as any[])!.some((el) =>
              (
                this.calculateRuleJson[key]["calculateValue"] as string
              ).includes(el.field.key)
            )
          ) {
            isRelativeEvent = true;
          }
        }
      });
    }
    if (isRelativeEvent) {
      this.message.warning("当前字段关联了触发事件，不允许删除!");
      return;
    }

    this.modalService.confirm({
      nzTitle: "提示",
      nzContent: `您确定要删除选中项？<br/><span class="delete_tips" >提示：如果该字段是内置字段，则删除无效。</br>&emsp;&emsp;&emsp;如果该字段关联了触发事件，则删除无效。</span>`,
      nzOnOk: () => {
        checkedList.forEach((item: any) => {
          this.business_form.fields.forEach((field, index, object) => {
            if (
              field.key === item.field.key &&
              _.get(field, "templateOptions.isButintin") != true
            ) {
              object.splice(index, 1);
            }
          });
        });
        this.initTableFieldStatus();

        this.initFormFieldPropertyAction();
        this.AddReferProcessDisabled = this.business_form.fields.some(
          (el) =>
            el.key === "comprehensive$df_comprehensiveapply$associationprocess"
        );
      },
    });
  }

  btnMoveUp() {
    let checkedList = this.getCheckFields();
    console.log(checkedList);

    if (checkedList == null || checkedList.length == 0) {
      this.message.warning("您当前没有选中任何项!");
      return;
    }
    // if (
    //   !_.isEmpty(checkedList) &&
    //   checkedList.some(
    //     (el: any) =>
    //       !!el.field.editProperty &&
    //       el.field.editProperty.canMove !== undefined &&
    //       el.field.editProperty.canMove === false
    //   )
    // ) {
    //   this.message.warning("您当前选中项包含不能移动项!");
    //   return;
    // }
    checkedList.forEach((item: any) => {
      if (item.index > 0) {
        // this.business_form.fields.splice(item.index, 1);
        // this.business_form.fields.splice(item.index - 1, 0, item.field);
        let i = 1;
        for (let index = item.index - 1; index > 0; index--) {
          const field = this.business_form.fields[index - 1];
          if (
            !!field.editProperty &&
            field.editProperty.canMove !== undefined &&
            field.editProperty.canMove === false
          ) {
            i++;
          } else {
            break;
          }
        }
        this.move(this.business_form.fields, item.index, item.index - i);
      }
    });
    this.initFormFieldPropertyAction();
  }

  move(arr: any, index: number, tindex: number) {
    //如果当前元素在拖动目标位置的下方，先将当前元素从数组拿出，数组长度-1，我们直接给数组拖动目标位置的地方新增一个和当前元素值一样的元素，
    //我们再把数组之前的那个拖动的元素删除掉，所以要len+1
    if (index > tindex) {
      arr.splice(tindex, 0, arr[index]);
      arr.splice(index + 1, 1);
    } else {
      //如果当前元素在拖动目标位置的上方，先将当前元素从数组拿出，数组长度-1，我们直接给数组拖动目标位置+1的地方新增一个和当前元素值一样的元素，
      //这时，数组len不变，我们再把数组之前的那个拖动的元素删除掉，下标还是index
      arr.splice(tindex + 1, 0, arr[index]);
      arr.splice(index, 1);
    }
  }

  btnMoveDown() {
    let checkedList = this.getCheckFields();
    console.log(checkedList);
    if (checkedList == null || checkedList.length == 0) {
      this.message.warning("您当前没有选中任何项!");
      return;
    }
    // if (
    //   !_.isEmpty(checkedList) &&
    //   checkedList.some(
    //     (el: any) =>
    //       !!el.field.editProperty &&
    //       el.field.editProperty.canMove !== undefined &&
    //       el.field.editProperty.canMove === false
    //   )
    // ) {
    //   this.message.warning("您当前选中项包含不能移动项!");
    //   return;
    // }
    checkedList.reverse().forEach((item) => {
      if (item.index < this.business_form.fields.length - 1) {
        let i = 1;
        for (
          let index = item.index;
          index < this.business_form.fields.length - 1;
          index++
        ) {
          const field = this.business_form.fields[index + 1];
          if (
            !!field.editProperty &&
            field.editProperty.canMove !== undefined &&
            field.editProperty.canMove === false
          ) {
            i++;
          } else {
            break;
          }
        }
        if (i > 1) {
          i--;
        }
        // this.business_form.fields.splice(item.index, 1);
        // this.business_form.fields.splice(item.index + 1, 0, item.field);
        this.move(this.business_form.fields, item.index, item.index + i);
      }
    });
    this.initFormFieldPropertyAction();
  }

  btnAddFields() {
    this.selectTableFields();
  }

  btnAddRemark() {
    this.kreTransferService.transferLabelToForm(
      this.business_form.fields,
      this.getCheckFields()
    );
    this.resetFormBuild();
    this.initFormFieldPropertyAction();
    this.initAnchorList();
  }

  btnAddLine() {
    this.kreTransferService.transferLineToForm(
      this.business_form.fields,
      this.getCheckFields()
    );
    this.resetFormBuild();
    this.initFormFieldPropertyAction();
  }
  btnAddAnchor() {
    this.kreTransferService.transferAnchorToForm(
      this.business_form.fields,
      this.getCheckFields()
    );
    this.resetFormBuild();
    this.initFormFieldPropertyAction();
  }
  btnAddReferProcess() {
    if (
      // this.business_form.fields.some(
      //   (el) =>
      //     el.key === "comprehensive$df_comprehensiveapply$associationprocess"
      // )
      this.AddReferProcessDisabled
    ) {
      // this.message.warning("一个流程最多只能有一个关联流程组件!");
      return;
    }
    // console.log(1);

    this.kreTransferService.transferReferProcessToForm(
      this.business_form.fields,
      this.getCheckFields()
    );
    this.resetFormBuild();
    this.initFormFieldPropertyAction();
    this.AddReferProcessDisabled = true;
  }

  btnAddGroup() {
    let tablecode = this.getTableMultipleCode();
    if (tablecode == null || tablecode == "") {
      this.message.warning("暂无可用的多记录区域可以添加");
      return;
    }
    if (
      this.business_tables &&
      this.business_tables.child &&
      this.business_tables.child.multiple &&
      this.business_tables.child.multiple.length > 0
    ) {
      if (
        this.business_tables.child.multiple.some((item: any) => {
          return item.tableQuote !== true;
        })
      ) {
        this.kreDialogService.CreateModelDialog(
          {
            nzTitle: "选择列表",
            size: "large",
            nzContent: KreFormDesignTables,
          },
          { businessTable: this.business_tables, tableType: "single" },
          (instance: any, modal: any) => {
            modal.destroy();
            if (
              instance.radioValue &&
              instance.radioValue !== null &&
              instance.radioValue !== ""
            ) {
              this.kreTransferService.transferGroupToForm(
                this.business_form.fields,
                this.getCheckFields(),
                instance.radioValue,
                this.business_tables
              );
            }
            this.initTableFieldStatus();
            this.initFormFieldPropertyAction();
          }
        );
      }
    }
  }

  btnColumn(type: number) {
    this.kreFormInfo.column = `layout-column-${type}`;
    this.layout_column = this.kreFormInfo.column;
    this.business_form.column = this.kreFormInfo.column;

    this.initFormFieldPropertyAction();
  }

  btnRow(type: number) {
    this.kreFormInfo.row = `layout-row-${type}`;
    this.layout_row = this.kreFormInfo.row;
    this.business_form.row = this.kreFormInfo.row;
    this.initFormFieldPropertyAction();
  }

  getCheckFields() {
    let checkedField: ICheckedField[] = [];
    this.business_form.fields.forEach((item, index) => {
      if (item.checked) {
        checkedField.push({ index: index, field: item });
      }
    });
    return checkedField;
  }

  /*按钮区域---end*/

  groupBtnMoveUpOrDown(groupField: KreFormFieldConfig, type: string) {
    if (
      !_.get(groupField, "fieldArray.fieldGroup") ||
      _.get(groupField, "fieldArray.fieldGroup").length < 1
    ) {
      groupField.fieldArray = {
        fieldGroup: [],
      };
    }
    let res = this.kreTransferService.groupFieldMoveUpOrDown(
      this.business_form.fields,
      groupField,
      type
    );
    if (res != null) {
      this.business_form.fields = res;
      if (groupField.key !== null && groupField.key !== undefined) {
        this.form_model[groupField.key] = [{}];
      }
      this.initFormFieldPropertyAction();
    }
  }

  groupBtnAddLineRemark(groupField: KreFormFieldConfig, type: string) {
    if (
      !_.get(groupField, "fieldArray.fieldGroup") ||
      _.get(groupField, "fieldArray.fieldGroup").length < 1
    ) {
      groupField.fieldArray = {
        fieldGroup: [],
      };
    }
    let res = null;
    if (type === "line") {
      res = this.kreTransferService.groupTransferLineToForm(
        this.business_form.fields,
        groupField
      );
    } else if (type === "remark") {
      res = this.kreTransferService.groupTransferRemarkToForm(
        this.business_form.fields,
        groupField
      );
    }
    if (res != null) {
      this.business_form.fields = res;
      if (groupField.key !== null && groupField.key !== undefined) {
        this.form_model[groupField.key] = [{}];
      }
      this.initFormFieldPropertyAction();
    }
  }

  groupBtnTableFields(groupField: KreFormFieldConfig) {
    console.log(groupField);

    this.kreDialogService.CreateModelDialog(
      {
        nzTitle: "选择列表",
        size: "large",
        nzContent: KreFormDesignTable,
      },
      {
        businessTable: this.business_tables,
        tableType: "multiple",
        fieldConfig: groupField,
      },
      (instance: any, modal: any) => {
        modal.destroy();
        let res = this.kreTransferService.groupTransferSelectFieldToForm(
          this.business_form.fields,
          groupField,
          _.cloneDeep(this.kreTransferService.getGroupCheckFields(groupField)),
          this.business_tables,
          instance.mapOfCheckedId
        );
        if (res != null) {
          this.business_form.fields = res;
          if (groupField.key !== null && groupField.key !== undefined) {
            this.form_model[groupField.key] = [{}];
          }
        }
        this.formBuilder.buildForm(
          this.form_group,
          this.business_form.fields,
          this.form_model,
          {}
        );
        this.initTableFieldStatus();
        this.initFormFieldPropertyAction();
      }
    );
  }

  groupBtnDeleteFields(groupField: KreFormFieldConfig) {
    if (
      !_.get(groupField, "fieldArray.fieldGroup") ||
      _.get(groupField, "fieldArray.fieldGroup").length < 1
    ) {
      return;
    }
    let res = this.kreTransferService.groupTransferDeleteForm(
      this.business_form.fields,
      groupField
    );
    if (res != null) {
      this.business_form.fields = res;
      if (groupField.key !== null && groupField.key !== undefined) {
        this.form_model[groupField.key] = [{}];
      }
    }
    this.initTableFieldStatus();
    this.initFormFieldPropertyAction();
    this.initAnchorList();
  }

  initTablesInfo() {
    this.business_tables;
    this.dataService
      .getBusinessTables(this.api.tables.url, { formcode: this.formCode })
      .subscribe((res) => {
        if (res != null) {
          this.business_tables = res;
        }
      });
  }

  initFormInfo(res: any) {
    if (res == undefined || res == null) {
      return;
    }
    this.kreFormInfo = {
      code: res.code,
      name: res.name,
      type: res.type,
      fields: res.fields,
    };
    if (
      this.kreFormInfo.fields !== null &&
      this.kreFormInfo.fields !== undefined
    ) {
      this.kreFormCommonService.initFormFieldModel(
        this.kreFormInfo.fields,
        this.form_model
      );

      // this.business_form.fields = this.kreFormInfo.fields;
    }
    if (res.column != undefined && res.column != null && res.column != "") {
      this.kreFormInfo.column = res.column;
    } else {
      this.kreFormInfo.column = "layout-column-3";
    }
    if (res.row != undefined && res.row != null && res.row != "") {
      this.kreFormInfo.row = res.row;
    } else {
      this.kreFormInfo.row = "layout-row-1";
    }
    if (
      this.kreFormInfo.column != undefined &&
      this.kreFormInfo.column != null &&
      this.kreFormInfo.row != undefined &&
      this.kreFormInfo.row != null
    ) {
      this.layout_column = this.kreFormInfo.column;
      this.layout_row = this.kreFormInfo.row;

      this.kreDesginToFormService.initFormFieldByTables(
        this.business_tables,
        this.business_form.fields
      );
      this.initTableFieldStatus();
    }
  }

  initTableFieldStatus() {
    this.kreDesginToFormService.initTableStatus(
      this.business_tables,
      this.business_form.fields
    );
    this.initTablesData();
  }

  initTablesData() {
    this.table_Data = [];
    let business = clone(this.business_tables);
    let tables: any = [];
    if (!business) return;

    if (business.primary && business.primary != null) {
      tables = [
        {
          tableType: "primary",
          tableLabel: "主表",
          tableCode: business.primary["tableCode"],
          tableName: business.primary["tableName"],
          tableFields: business.primary["tableFields"],
        },
      ];
    }
    if (
      business.child &&
      business.child != null &&
      business.child.single &&
      business.child.single != null &&
      business.child.single.length > 0
    ) {
      if (Array.isArray(business.child.single)) {
        business.child.single.forEach((item: any) => {
          tables.push({
            tableType: "single",
            tableLabel: "单记录子表",
            tableCode: item["tableCode"],
            tableName: item["tableName"],
            tableFields: item["tableFields"],
          });
        });
      }
    }
    if (
      business.child &&
      business.child != null &&
      business.child.multiple &&
      business.child.multiple != null &&
      business.child.multiple.length > 0
    ) {
      if (Array.isArray(business.child.multiple)) {
        business.child.multiple.forEach((item: any) => {
          tables.push({
            tableType: "multiple",
            tableLabel: "多记录子表",
            tableCode: item["tableCode"],
            tableName: item["tableName"],
            tableFields: item["tableFields"],
          });
        });
      }
    }
    this.table_Data = tables;
  }

  //表单选择
  selectTableFields() {
    this.kreDialogService.CreateModelDialog(
      {
        nzTitle: "选择列表",
        size: "large",
        nzContent: KreFormDesignTable,
      },
      { businessTable: this.business_tables, tableType: "single" },
      (instance: any, modal: any) => {
        modal.destroy();
        this.kreTransferService.transferSelectFieldToForm(
          this.business_form.fields,
          this.getCheckFields(),
          this.business_tables,
          instance.mapOfCheckedId
        );
        this.initTableFieldStatus();
        this.formBuilder.buildForm(
          this.form_group,
          this.business_form.fields,
          this.form_model,
          {}
        );
        this.initFormFieldPropertyAction();
      }
    );
  }

  getTableMultipleCode() {
    let resTableCode = "";
    if (
      this.business_tables &&
      this.business_tables.child &&
      this.business_tables.child.multiple &&
      this.business_tables.child.multiple.length > 0
    ) {
      this.business_tables.child.multiple.forEach((item: any) => {
        if (item.tableQuote !== true && resTableCode == "") {
          resTableCode = item.tableCode;
        }
      });
    }
    return resTableCode;
  }

  //修改Field
  editFormFieldConfig(field: KreFormFieldConfig) {
    let content: any;
    let title = "";
    if (field.type === "html") {
      title = "编辑片段文本描述";
      content = KreFormDSFieldLabel;
    } else if (field.type === "repeat") {
      title = "编辑多记录区";
      content = KreFormDSField;
    } else if (field.type === "tabular") {
      title = "编辑加班区域";
      content = KreFormDSField;
    } else if (field.type === "htmlcontent") {
      title = "编辑文本";
      content = KreFormDSField;
    } else {
      title = "编辑字段 - " + _.get(field, "templateOptions.label");
      content = KreFormDSField;
    }
    this.kreDialogService.CreateModelDialogField(
      {
        nzTitle: title,
        size: "large",
        nzContent: content,
      },
      {
        langConfig: this.langConfig,
        field: clone(field),
        modalType: "default",
        options: this.options,
      },
      (type: any, instance: any, modal: any) => {
        if (instance.checkSave()) {
          let result = this.kreTransferService.editFormFieldInfo(
            this.business_form.fields,
            instance.formField
          );
          if (result != null) {
            this.business_form.fields = result.formFileds;
            if (result.groupKey != null && result.groupKey != "") {
              this.form_model[result.groupKey] = [{}];
            }
          }
          this.initFormFieldPropertyAction();
          if (field.type === "htmlcontent") {
            this.initAnchorList();
          }

          modal.destroy();
        }
      }
    );
  }

  //删除Field
  deleteFormFieldConfig(field: KreFormFieldConfig) {
    let isRelativeEvent = false;
    if (!!this.triggerJson && !_.isEmpty(this.triggerJson)) {
      // isRelativeEvent = (Object.keys(this.triggerJson) as any).includes(
      //   field.key
      // );

      Object.keys(this.triggerJson).forEach((key) => {
        if (key === field.key && this.triggerJson[key].length > 0) {
          isRelativeEvent = true;
        }
        (this.triggerJson[key] as any[])!.forEach((el) => {
          if (el.fieldKey === field.key) {
            isRelativeEvent = true;
          }
        });
      });
    }
    if (!!this.calculateRuleJson && !_.isEmpty(this.calculateRuleJson)) {
      isRelativeEvent = (Object.keys(this.calculateRuleJson) as any).includes(
        field.key
      );
      Object.keys(this.calculateRuleJson).forEach((key) => {
        if (
          !!this.calculateRuleJson[key] &&
          !!this.calculateRuleJson[key]["calculateValue"] &&
          (this.calculateRuleJson[key]["calculateValue"] as string).includes(
            field.key
          )
        ) {
          isRelativeEvent = true;
        }
      });
    }

    if (isRelativeEvent) {
      this.message.warning("当前字段关联了触发事件，不允许删除!");
      return;
    }

    let result = this.kreTransferService.deleteFormFieldInfo(
      this.business_form.fields,
      field
    );

    if (result != null) {
      this.business_form.fields = result.formFileds;
      if (result.groupKey != null && result.groupKey != "") {
        this.form_model[result.groupKey] = [{}];
      }

      this.initTableFieldStatus();
      this.initFormFieldPropertyAction();
    }
    this.initAnchorList();
  }

  resetFormBuild() {
    this.formBuilder.buildForm(
      this.form_group,
      this.business_form.fields,
      this.form_model,
      {}
    );
  }

  initFormFieldPropertyAction() {
    let newFormInfo: any = _.cloneDeep(this.business_form);
    this.kreFormCommonService.initFormFieldProperty(newFormInfo.fields);
    this.actionEvent.emit({
      newFormInfo,
      triggerJson: this.triggerJson,
      calculateRuleJson: this.calculateRuleJson,
    });
  }
  modelChange(e: any) {}
  initAnchorList() {
    this.anchorList = [];
    this.key = "";
    this.business_form.fields.forEach((el) => {
      if (el.type === "htmlcontent" && el!.templateOptions!.isNav) {
        this.anchorList.push(el);
      }
    });
    this.anchorDevList = {};
    setTimeout(() => {
      if (this.anchorList.length > 0) {
        this.anchorList.forEach((el, index) => {
          if (!el!.templateOptions!.description) {
            el!.templateOptions!.description = `默认导航${index + 1}`;
          }
          document!.getElementById("conter")!.scrollTop = 0;
          this.anchorDevList[el.key] = (
            document!.getElementById(el.key)!.getBoundingClientRect() as any
          )["y"];
        });
      }
    }, 100);
  }
  at(str: string) {
    if (!!this.key && str === this.key) {
      return;
    }
    this.key = str;
    const anchorDevList = _.cloneDeep(this.anchorDevList);
    document!.getElementById("conter")!.scrollTop =
      anchorDevList[this.key] - 197;
  }
}
